import React from 'react'
import styled from 'styled-components'
import { ReactComponent as LogoImg } from '../images/logo_footer.svg'
import { URL } from "../common/constants"
import { Link } from "react-router-dom"

function Footer() {
  return (
    <Container>
      <TopSection>
        <TopLeft>
          <LogoImg />
        </TopLeft>
        <TopRight style={{ display: 'none' }}>
          <FooterLink to="/templates">템플릿</FooterLink>
          <FooterLink to="/community">커뮤니티</FooterLink>
          <FooterAnchor href={URL.HISTORY} target="_blank" rel="noopener noreferrer">
            히스토리
          </FooterAnchor>
        </TopRight>
      </TopSection>
      <BottomSection>
        <CompanyInfo>
          <span>VALOY(발로이)</span>
          <span>사업자번호: 564-09-00870</span>
          <span>대표: 권해림, 김지수</span>
          <LegalLinks>
            <a href={URL.TERMS_OF_SERVICE} target="_blank" rel="noopener noreferrer">이용약관</a>
            <Sep>|</Sep>
            <a href={URL.PRIVACY_POLICY} target="_blank" rel="noopener noreferrer">개인정보처리방침</a>
            <Sep>|</Sep>
            <a href={"mailto:" + URL.MAIL} target="_blank" rel="noopener noreferrer">문의하기</a>
          </LegalLinks>
        </CompanyInfo>
        <CopyrightRow>
          <p>© 2020-{new Date().getFullYear()} VALOY ALL RIGHTS RESERVED</p>
        </CopyrightRow>
      </BottomSection>
    </Container>
  )
}

const Container = styled.footer`
  background: #f8f8ff;
  padding: 0 5.75rem;
  color: #8b95a1;

  @media (max-width: 800px) {
    padding: 0 2rem 70px;
  }
`

const TopSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 32px 0 0;

  @media (max-width: 800px) {
    padding: 24px 0 0;
  }
`

const TopLeft = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`

const TopRight = styled.div`
  display: flex;
  align-items: center;
  gap: 32px;

  @media (max-width: 800px) {
    gap: 24px;
  }
`

const footerLinkStyles = `
  font-size: 0.875rem;
  font-weight: 500;
  color: #181433;
  &:hover {
    color: #5551ff;
  }
`

const FooterLink = styled(Link)`
  ${footerLinkStyles}
`

const FooterAnchor = styled.a`
  ${footerLinkStyles}
`

const BottomSection = styled.div`
  padding: 16px 0 24px;
  text-align: center;

  @media (max-width: 800px) {
    padding: 20px 0 0;
  }
`

const CompanyInfo = styled.p`
  margin-bottom: 4px;
  font-size: 0.75rem;
  letter-spacing: 0.03em;
  color: #acacb1;
  line-height: 150%;

  span {
    display: inline-block;
    margin-right: 8px;
  }

  @media (max-width: 800px) {
    white-space: pre-line;
  }
`

const CopyrightRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
  font-size: 0.75rem;
  letter-spacing: 0.03em;
  color: #acacb1;
  line-height: 150%;

  > p {
    white-space: nowrap;
  }

  @media (max-width: 800px) {
    flex-direction: column;
    gap: 8px;
    margin-top: 8px;
  }
`

const LegalLinks = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 12px;
  margin-left: 12px;

  a {
    color: #acacb1;
    white-space: nowrap;
    text-decoration: none;
    &:hover {
      color: #5551ff;
      text-decoration: underline;
    }
  }
`

const Sep = styled.span`
  color: #d1d5db;
  font-size: 0.65rem;
  margin: 0 4px;
`

export default Footer
